import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { Button, Card, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { CloseSvg } from "../../../../components/CommonSvg";
import {
    DATE_FORMATER,
    VENDOR_LOG_CATEGORY_OPTIONS,
} from "../../../../constant/commonConstants";

function VendorLogFilter({
    filter,
    setFilter,
    handelShowFIlter,
    /* page-supplied buttons that belong with the filter, sitting beside
       Clear all - see VendorLogs' Delete Activity */
    actions,
}) {
    const selectedCategory =
        VENDOR_LOG_CATEGORY_OPTIONS.find(
            (option) => option.value === filter.category
        ) || null;

    const handelClearAll = () => {
        setFilter({ category: "", fromDate: null, toDate: null });
    };

    return (
        <Card className="filter_section vendor_log_filter">
            <CardBody>
                <h6 className="separate-head">Filter</h6>
                <div className="vendor_log_filter_actions">
                    {actions}
                    <Button
                        className="clear_btn btn-primary"
                        style={{ color: "black" }}
                        onClick={handelClearAll}
                    >
                        Clear all
                    </Button>
                </div>

                <form className="hra-create">
                    <Row>
                        <Col className="no-floating-label">
                            <FormGroup>
                                <Select
                                    id="category"
                                    name="category"
                                    className="form-control selectbox"
                                    menuPlacement="auto"
                                    options={VENDOR_LOG_CATEGORY_OPTIONS}
                                    value={selectedCategory}
                                    onChange={(option) =>
                                        setFilter({
                                            ...filter,
                                            category: option ? option.value : "",
                                        })
                                    }
                                    isClearable
                                />
                                <Label className="form-label" htmlFor="category">
                                    Activity
                                </Label>
                            </FormGroup>

                            <Button
                                className="my-tooltip cancel_filter"
                                data-tooltip-content={"Close filter"}
                                color="link"
                                onClick={handelShowFIlter}
                            >
                                <CloseSvg />
                            </Button>
                        </Col>

                        <Col className="no-floating-label">
                            <FormGroup>
                                <DatePicker
                                    id="fromDate"
                                    className="form-control"
                                    dateFormat={DATE_FORMATER}
                                    placeholderText="From date"
                                    selected={filter.fromDate}
                                    maxDate={filter.toDate || new Date()}
                                    isClearable
                                    onChange={(date) =>
                                        setFilter({ ...filter, fromDate: date })
                                    }
                                />
                                <Label className="form-label" htmlFor="fromDate">
                                    From
                                </Label>
                            </FormGroup>
                        </Col>

                        <Col className="no-floating-label">
                            <FormGroup>
                                <DatePicker
                                    id="toDate"
                                    className="form-control"
                                    dateFormat={DATE_FORMATER}
                                    placeholderText="To date"
                                    selected={filter.toDate}
                                    minDate={filter.fromDate}
                                    maxDate={new Date()}
                                    isClearable
                                    onChange={(date) =>
                                        setFilter({ ...filter, toDate: date })
                                    }
                                />
                                <Label className="form-label" htmlFor="toDate">
                                    To
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </CardBody>
        </Card>
    );
}

export default VendorLogFilter;
